import http from "./httpService";

const apiEndpoint = `/journals`;

function journalUrl(journalId) {
  return `${apiEndpoint}/${journalId}`;
}

export function getJournals(
  pageNumber,
  pageSize,
  start = 0,
  end = 0,
  sort = "desc"
) {
  return http.get(
    `${apiEndpoint}?pageNumber=${pageNumber}&pageSize=${pageSize}&start=${start}&end=${end}&sort=${sort}`
  );
}

export function getStarredJournals(pageNumber, pageSize, sort = "desc") {
  return http.get(
    `${apiEndpoint}/starred?pageNumber=${pageNumber}&pageSize=${pageSize}&sort=${sort}`
  );
}

export function getLockedJournals(pageNumber, pageSize, sort = "desc") {
  return http.get(
    `${apiEndpoint}/locked?pageNumber=${pageNumber}&pageSize=${pageSize}&sort=${sort}`
  );
}

export function searchJournals(pageNumber, pageSize, term, sort = "desc") {
  return http.get(
    `${apiEndpoint}/search?term=${encodeURIComponent(
      term
    )}&pageNumber=${pageNumber}&pageSize=${pageSize}&sort=${sort}`
  );
}

export function getTagsList() {
  return http.get(`${apiEndpoint}/tags`);
}

export function getJournalsByTag(tag, pageNumber, pageSize, sort = "desc") {
  return http.get(
    `${apiEndpoint}/tag?tag=${encodeURIComponent(
      tag
    )}&pageNumber=${pageNumber}&pageSize=${pageSize}&sort=${sort}`
  );
}

export function saveTagOrder(order) {
  return http.put(`${apiEndpoint}/tags/order`, { order });
}

export function getJournal(journalId) {
  return http.get(`${apiEndpoint}/${journalId}`);
}

export function getRandomJournal() {
  return http.get(`${apiEndpoint}/random`);
}

export function getJournalStats() {
  return http.get(`${apiEndpoint}/stats`);
}

export function saveJournal(journal) {
  if (journal._id) {
    const body = { ...journal };
    delete body._id;
    return http.put(journalUrl(journal._id), body);
  }

  return http.post(apiEndpoint, journal);
}

export function deleteJournal(journalId) {
  return http.delete(`${apiEndpoint}/${journalId}`);
}
